<template>
    <MainContent title="Editar deportista">
        <template v-slot:header>
            <h3 class="card-title p-0">Editar deportista</h3>
        </template>
        <template v-slot:content>
            <ValidationObserver v-if="!loading" tag="form" ref="observer" @submit.prevent="submit()">
                <div>
                    <FormNino :base="base"></FormNino><br/>
                    <FormResponsables :base="base"></FormResponsables><br/>
                    <FormFoto :base="base" @update="getBase(base_id)"></FormFoto><br/>
                    <div class="col-12 text-right mt-3">
                        <Button type="submit" name="button" :disabled="loading">GUARDAR</Button>
                    </div>
                </div>
            </ValidationObserver>
            <LoaderComponent v-else></LoaderComponent>
        </template>
    </MainContent>
</template>

<script>
import MainContent from "@/components/backend/components/MainContent";
import FormNino from "@/components/backend/bases/components/forms/FormNino";
import FormResponsables from "@/components/backend/bases/components/forms/FormResponsables";
import FormFoto from "@/components/backend/bases/components/forms/FormFoto";
export default {
    data() {
        return {
            loading: false,
            base: null,
            base_id: this.$route.params.base_id,
            lista_id: this.$route.params.lista_id
        }
    },
    methods: {
        getBase(base_id) {
            this.loading = true;
            const params = {
                base_id: base_id,
                filters:  {
                    lista_id: this.lista_id
                }
            };

            this.$store.dispatch(this.config.getVuexAlias('back.bases.show'), params).then(res => {
                this.base = res.data.data;
                this.loading = false;
            });
        },
        editarBase() {
            this.loading = true;
            this.base.filters = {};

            this.base.base_id = this.base_id;
            this.base.equipo_id = this.base['equipo'] ? this.base['equipo']['id'] : null;

            this.$store.dispatch(this.config.getVuexAlias('back.bases.update'), this.base).then(res => {
                this.$toast.success(res.data.message);
                this.$router.push({ name: 'back.bases.index' });
                this.loading = false;
            }).catch(error => {
                this.$toast.error(error.response.data.message);
                this.loading = false;
            });
        },
        async submit() {
            const isValid = await this.$refs.observer.validate();
            if(isValid) {
                this.editarBase();
            }
        }
    },
    created() {
        this.getBase(this.base_id);
    },
    components: { MainContent, FormNino, FormResponsables, FormFoto }
}
</script>